<template>
  <div id="main-screen" style="overflow:hidden;">
    <div class="main-content"  style="overflow:auto;">
      <div class="main-left">
        <div class="left-body" v-for="(item, index) in leftDevice" :key="index">
          <div class="left-body-title">{{item.name}}</div>
          <div class="left-body-content">
            <dv-border-box12>
              <div class="left-content-block" style="padding-top: 3%">
                <div class="left-content-block-container">
                  <span class="left-container-name">{{item.deviceName}}</span>
                </div>
                <div class="left-content-block-container">
                  <span class="left-container-value">{{item.deviceNum}}</span>
                </div>
              </div>

              <dv-decoration-2 style="width:90%;height:1%;margin-left: 5%;" />

              <div class="left-content-block">
                <div class="left-content-block-container">
                  <span class="left-container-name">{{item.onLineName}}</span>
                </div>
                <div class="left-content-block-container">
                  <span class="left-container-value">{{item.onLineNum}}</span>
                </div>
              </div>

              <dv-decoration-2 style="width:90%;height:1%;margin-left: 5%;" />

              <div class="left-content-block">
                <div class="left-content-block-container">
                  <span class="left-container-name">{{item.offLineName}}</span>
                </div>
                <div class="left-content-block-container">
                  <span class="left-container-value">{{item.offLineNum}}</span>
                </div>
              </div>
            </dv-border-box12>
          </div>
        </div>
      </div>

      <div class="main-middle">
        <map-data ref="mapData"/>
      </div>

      <div class="main-right" >
        <div class="main-right-top">
          <div class="main-right-topBody"  v-for="(item, index) in rightDevice" :key="index">
            <div class="main-right-topBody-title">{{item.name}}</div>
            <div class="main-right-topBody-content">
              <dv-border-box12>
                <div class="right-topBody-content-block" style="padding-top: 3%; ">
                  <div class="right-topBody-content-block-container">
                    <span class="right-topBody-container-name">{{item.deviceName}}</span>
                  </div>
                  <div class="right-topBody-content-block-container">
                    <span style="display: table-cell;vertical-align: middle;text-align: center;color: #ffffff;font-size: 28px;">{{item.deviceNum}}</span>
                  </div>
                </div>

                <dv-decoration-2 style="width:90%;height:1%;margin-left: 5%;" />

                <div class="right-topBody-content-block">
                  <div class="right-topBody-content-block-container">
                    <span class="right-topBody-container-name">{{item.onLineName}}</span>
                  </div>
                  <div class="right-topBody-content-block-container">
                    <span class="right-topBody-container-value">{{item.onLineNum}}</span>
                  </div>
                </div>

                <dv-decoration-2 style="width:90%;height:1%;margin-left: 5%;" />

                <div class="right-topBody-content-block">
                  <div class="right-topBody-content-block-container">
                    <span class="right-topBody-container-name">{{item.offLineName}}</span>
                  </div>
                  <div class="right-topBody-content-block-container">
                    <span class="right-topBody-container-value">{{item.offLineNum}}</span>
                  </div>
                </div>
              </dv-border-box12>
            </div>
          </div>
        </div>

        <div class="main-right-bottom">
          <div class="main-right-bottom-body">
            <div class="main-right-bottomBody-Title">其余设备统计</div>
            <div class="main-right-bottomBody-container">
              <dv-border-box12>
<!--                <div class="right-bottomBody-container-block">-->
<!--                  <div class="right-bottomBody-content-block-container">-->
<!--                    <span class="right-bottomBody-container-name">设备数</span>-->
<!--                  </div>-->
<!--                  <div class="right-bottomBody-content-block-container">-->
<!--                    <span class="right-bottomBody-container-value">{{seedDevice}}</span>-->
<!--                  </div>-->
<!--                </div>-->
                <div class="right-bottomBody-container-block">
                  <div class="right-bottomBody-content-block-container">
                    <div class="right-bottomBody-container-name">苗情设备</div>
                  </div>
                  <div class="right-bottomBody-content-block-container">
                    <div class="right-bottomBody-container-value">{{seedDevice}}</div>
                  </div>
                </div>
                <dv-decoration-2 style="width:90%;height:1%;margin-left: 5%;" />
                <div class="right-bottomBody-container-block">
                  <div class="right-bottomBody-content-block-container">
                    <div class="right-bottomBody-container-name">杀虫灯设备</div>
                  </div>
                  <div class="right-bottomBody-content-block-container">
                    <div class="right-bottomBody-container-value">{{fxscdDevice}}</div>
                  </div>
                </div>
              </dv-border-box12>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import mapData from "./MapData"
  import moment from "moment"
  import {getAttributesShared} from "../../until/api/MeteSoil";
  export default {
    name: 'MainScreen',
    components:{
      mapData
    },
    data() {
      return {
        leftDevice:[
          {"name": '总设备统计', "deviceName": '总设备', "deviceNum": 0, "onLineName": '在线设备', "onLineNum": 0, "offLineName": '离线设备', "offLineNum": 0},
          {"name": '虫情设备统计', "deviceName": '设备数', "deviceNum": 0, "onLineName": '在线设备', "onLineNum": 0, "offLineName": '离线设备', "offLineNum": 0},
          {"name": '孢子设备统计', "deviceName": '设备数', "deviceNum": 0, "onLineName": '在线设备', "onLineNum": 0, "offLineName": '离线设备', "offLineNum": 0},
        ],
        rightDevice:[
          {"name":'气象设备统计',"deviceName":'设备数', "deviceNum": 0, "onLineName": '在线设备', "onLineNum": 0, "offLineName": '离线设备', "offLineNum": 0},
          {"name":'墒情设备统计',"deviceName":'设备数', "deviceNum": 0, "onLineName": '在线设备', "onLineNum": 0, "offLineName": '离线设备', "offLineNum": 0}
        ],
        totalDevice: 0,
        onTotalDevice: 0,
        offTotalDevice: 0,
        meteDevice: 0,
        onMeteDevice: 0,
        offMeteDevice: 0,
        soilDevice: 0,
        onSoilDevice: 0,
        offSoilDevice: 0,
        seedDevice: 0,
        fxscdDevice: 0,
        pestDevice: 0,
        onPestDevice: 0,
        offPestDevice: 0,
        sporeDevice: 0,
        onSporeDevice: 0,
        offSporeDevice: 0,
        deviceIdList: [],
        wormList: [],
        sporeList: [],
        errorNum: 0,
      }
    },

    mounted() {
      //获取用户等级
      //let authority = this.$route.params.authority === undefined ? localStorage.getItem('authority') : this.$route.params.authority;
      let authority = this.$route.params.authority === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('authority')) : this.$route.params.authority;
      //获取用户id
      //let customerId = this.$route.params.customerId === undefined ? localStorage.getItem('customerId') : this.$route.params.customerId;
      let customerId = this.$route.params.customerId === undefined ? this.$commonFun.unCompileStr(localStorage.getItem('customerId')) : this.$route.params.customerId;

      let that = this;
      this.$MeteSoilCommon.getDeviceList(authority, customerId, function (deviceList) {//获取设备列表
        if(deviceList.data.length > 0) {
          for(let i = 0; i < deviceList.data.length; i++) {
            let deviceId = {};
            deviceId.id = deviceList.data[i].id.id;
            deviceId.name = deviceList.data[i].name;
            deviceId.type = deviceList.data[i].id.entityType;
            that.deviceIdList.push(deviceId);
          }
          that.getDeviceInfo(0, that.deviceIdList.length);//获取每一个设备信息
        } else {
          that.getSPDeviceList();
        }
      })
    },

    methods: {
      /**
       * 使用递归获取每一个设备信息
       * @param j
       * @param length
       */
      getDeviceInfo(j, length) {
        let that = this;
        this.$MeteSoilCommon.getCredentialsInfo(this.deviceIdList[j].id, function (deviceInfo) {//获取设备信息
          that.deviceIdList[j].deviceInfo = deviceInfo;
          if(++j < length) {
            that.getDeviceInfo(j, length) //使用递归获取每一个设备信息
          } else {
            that.getDeviceKeyInfo(0, that.deviceIdList.length);//获取每隔设备key属性
          }
        })
      },

      /**
       * 使用递归获取每一个设备的key属性
       * @param j
       * @param length
       */
      getDeviceKeyInfo(j, length) {
        let that = this;
        this.$MeteSoilCommon.getDeviceKeyList(this.deviceIdList[j].deviceInfo, function (keyData) {//获取设备key
          that.deviceIdList[j].keyList = keyData;
          if(++j < length) {
            that.getDeviceKeyInfo(j, length)//使用递归获取每一个设备的key属性
          } else {
            that.getSoilMeteNum(0, that.deviceIdList.length); //获取设备状态
          }
        })
      },

      /**
       * 使用递归判断每个设备是否在线
       * @param j
       * @param length
       */
      getSoilMeteNum(j, length) {
        let that = this;
        let beforeTime = new Date(moment().subtract(1, "hours")).getTime();//一小时前时间戳
        this.$MeteSoilCommon.getLastConnectTime(this.deviceIdList[j].type, this.deviceIdList[j].id).then(lastTime => {
          //获取最后一次连接设备时间
          //总设备状态
          if(beforeTime < lastTime) {
            that.onTotalDevice++;//总在线设备
          } else {
            that.offTotalDevice++;//总离线设备
          }

          //筛选非墒情属性并获取气象设备状态
          let keyList = that.deviceIdList[j].keyList.split(',');
          let strKey = '';
          //筛选非墒情属性
          for(let i = 0; i < keyList.length; i++) {
            if(keyList[i].indexOf('soil') < 0 && keyList[i].indexOf('fxd_') < 0) {
              i == keyList.length - 1 ? strKey += keyList[i] : strKey += keyList[i] + ','
            }
          }

          //获取每个气象设备的状态
          if(strKey != '') {
            that.meteDevice++; //气象总设备数量
            if(beforeTime < lastTime) {
              that.onMeteDevice++; //气象在线设备数量
            } else {
              that.offMeteDevice++; //气象离线设备数量
            }
          }

          // if(that.deviceIdList[j].keyList.indexOf('soil') < 0) {
          //   that.meteDevice++;
          //   if(beforeTime < lastTime) {
          //     that.onMeteDevice++;
          //   } else {
          //     that.offMeteDevice++;
          //   }
          // }

          //墒情设备在线状态
          if(that.deviceIdList[j].keyList.indexOf('soil') >= 0) {
            that.soilDevice++;//墒情总设备数量
            if(beforeTime < lastTime) {
              that.onSoilDevice++; //墒情在线设备数量
            } else {
              that.offSoilDevice++; //墒情离线涉笔数量
            }
          }

          if(that.deviceIdList[j].keyList.indexOf("fxd_") >= 0) {
            that.fxscdDevice++;
          }

          if(++j < length) {
            that.getSoilMeteNum(j, length) //使用递归判断每隔设备是否在线
          } else {
            that.totalDevice = that.deviceIdList.length;
            that.leftDevice[0].deviceNum = that.totalDevice; //总设备
            that.leftDevice[0].onLineNum = that.onTotalDevice;//在线设备
            that.leftDevice[0].offLineNum = that.offTotalDevice;//离线设备

            that.rightDevice[0].deviceNum = that.meteDevice;//气象总设备
            that.rightDevice[0].onLineNum = that.onMeteDevice;//气象在线设备
            that.rightDevice[0].offLineNum = that.offMeteDevice;//气象离线设备

            that.rightDevice[1].deviceNum = that.soilDevice;//墒情总设备
            that.rightDevice[1].onLineNum = that.onSoilDevice; //墒情在线设备
            that.rightDevice[1].offLineNum = that.offSoilDevice;// 墒情离线设备

            that.getSeedNum(0, that.deviceIdList.length);
          }
        })
      },

      /**
       * 使用递归获取每个设备下的摄像头数量（苗情数量）
       * @param j
       * @param length
       */
      getSeedNum(j, length) {
        getAttributesShared(this.deviceIdList[j].deviceInfo.entityType, this.deviceIdList[j].deviceInfo.id).then(response => {//访问服务端api
          for(let i = 0; i < response.data.length; i++) {
            if(response.data[i].key.toString().indexOf('vedio') !== -1) {//判断是否有摄像头
              this.seedDevice++;//累计摄像头数量
            }
          }
          if(++j < length) {
            this.getSeedNum(j, length);// 使用递归获取每个设备下的摄像头数量（苗情数量）
          } else {
            if(localStorage.getItem('spToken') != null) {
              this.getSPDeviceList(); //获取虫情孢子设备列表
            }
          }
        }).catch(error => {
          console.log("error", error)
        });
      },

      /**
       * 获取虫情孢子设备列表
       */
      getSPDeviceList() {
        let that = this;
        this.$SporeSoilCommon.getSpDeviceList(function (spDeviceList) {
          if(spDeviceList.code != 2000) {
            that.errorNum = 0;
            for(let i = 0; i < spDeviceList.data.length; i++) {
              if(spDeviceList.data[i].deviceType.indexOf('worm') > -1) {
                let wormJson = {};
                wormJson.deviceAddr = spDeviceList.data[i].deviceAddr;
                wormJson.deviceName =  spDeviceList.data[i].deviceName;
                wormJson.deviceType =  spDeviceList.data[i].deviceType;
                that.wormList.push(wormJson);
              } else if(spDeviceList.data[i].deviceType == 'spore') {
                let sporeJson = {};
                sporeJson.deviceAddr = spDeviceList.data[i].deviceAddr;
                sporeJson.deviceName =  spDeviceList.data[i].deviceName;
                sporeJson.deviceType =  spDeviceList.data[i].deviceType;
                that.sporeList.push(sporeJson);
              }
            }

            if(that.wormList.length > 0) {
              that.getPestNum(0, that.wormList.length);// 使用递归获取虫情设备在线以及离线数量
            } else if(that.sporeList.length > 0) {
              that.getSporeNum(0, that.sporeList.length)  //使用递归获取孢子设备在线以及离线数量
            }
          } else if(spDeviceList.code == 2000){
            that.errorNum++;
            if(that.errorNum < 4) {
              that.getSPDeviceList();
              that.errorNum = 0;
            } else {
              that.errorNum = 0;
            }
          }
        })
      },

      /**
       * 使用递归获取虫情设备在线以及离线数量
       * @param j
       * @param length
       */
      getPestNum(j, length) {
        let that = this;
        this.$SporeSoilCommon.spRealDataTime(this.wormList[j].deviceAddr,function (wormList) {
          if(wormList.code != 1005) {
            for(let i = 0; i < wormList.data.length; i++) {
              that.totalDevice++;
              that.pestDevice++;
              if(wormList.data[i].status == 'online') {//虫情在线数量
                that.onTotalDevice++;
                that.onPestDevice++;
              } else {//虫情离线设备
                that.offTotalDevice++;
                that.offPestDevice++;
              }
            }

            if(wormList.data.length == 0) {
              that.totalDevice++;
              that.pestDevice++;
              that.offTotalDevice++;
              that.offPestDevice++;
            }

            //console.log("666666", that.pestDevice, that.onTotalDevice, that.offPestDevice)
            if(++j < length) {
              that.getPestNum(j, length) //使用递归获取虫情设备在线以及离线数量
            } else {
              that.leftDevice[0].deviceNum = that.totalDevice;//总设备数量
              that.leftDevice[0].onLineNum = that.onTotalDevice;//在线设备
              that.leftDevice[0].offLineNum = that.offTotalDevice;//离线设备

              that.leftDevice[1].deviceNum = that.pestDevice; //虫情总设备
              that.leftDevice[1].onLineNum = that.onPestDevice; //虫情在线设备
              that.leftDevice[1].offLineNum = that.offPestDevice; //虫情离线设备

              if(that.sporeList.length > 0) {
                that.getSporeNum(0, that.sporeList.length)  //使用递归获取孢子设备在线以及离线数量
              }
            }
          }
          else {
            that.$message({
              showClose: true,
              type: 'warning',
              message: '访问过于频繁，请稍后再试'
            })
          }
        })
      },

      /**
       * 使用递归获取孢子设备在线以及离线数量
       * @param j
       * @param length
       */
      getSporeNum(j, length){
        let that = this;
        this.$SporeSoilCommon.spRealDataTime(this.sporeList[j].deviceAddr, function (sporeList) {
          if(sporeList.code != 1005) {
            for(let i = 0; i < sporeList.data.length; i++) {
              that.totalDevice++;
              that.sporeDevice++;
              if(sporeList.data[i].status == 'online'){//孢子在线数量
                that.onTotalDevice++;
                that.onSporeDevice++;
              } else {//孢子离线数量
                that.offTotalDevice++;
                that.offSporeDevice++;
              }
            }

            if(sporeList.data.length == 0) {
              that.totalDevice++;
              that.sporeDevice++;
              that.offTotalDevice++;
              that.offSporeDevice++;
            }

            if(++j < length) {
              that.getSporeNum(j, length);
            } else {
              that.leftDevice[0].deviceNum = that.totalDevice; //总设备数量
              that.leftDevice[0].onLineNum = that.onTotalDevice; //在线设备数量
              that.leftDevice[0].offLineNum = that.offTotalDevice; //离线设备数量

              that.leftDevice[2].deviceNum = that.sporeDevice; //孢子总设备
              that.leftDevice[2].onLineNum = that.onSporeDevice;//孢子在线设备数
              that.leftDevice[2].offLineNum = that.offSporeDevice;//孢子离线数
            }
          } else {
            that.$message({
              showClose: true,
              type: 'warning',
              message: '访问过于频繁，请稍后再试'
            })
          }
        })
      }
    }
  }
</script>

<style lang="less">
  @import "../less/MainScreen";
</style>

<style>
  .main-content::-webkit-scrollbar {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/view/MainScreen.vue